// kenoContractABI.js
const kenoContractABI = [
    {
      "inputs": [{"internalType": "uint8[]", "name": "selectedNumbers", "type": "uint8[]"}],
      "name": "placeBet",
      "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "calculateVRFFee",
      "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getHouseBalance",
      "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getMaxBet",
      "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [{"internalType": "address", "name": "player", "type": "address"}],
      "name": "hasPendingBet",
      "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [{"internalType": "address", "name": "", "type": "address"}],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPayoutTable",
      "outputs": [{"internalType": "uint256[]", "name": "", "type": "uint256[]"}],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [{"internalType": "uint8", "name": "hits", "type": "uint8"}],
      "name": "getPayoutMultiplier",
      "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "addLiquidity",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [{"internalType": "uint256", "name": "amount", "type": "uint256"}],
      "name": "removeLiquidity",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "anonymous": false,
      "inputs": [
        {"indexed": true, "internalType": "address", "name": "player", "type": "address"},
        {"indexed": true, "internalType": "uint256", "name": "requestId", "type": "uint256"},
        {"indexed": false, "internalType": "uint256", "name": "betAmount", "type": "uint256"},
        {"indexed": false, "internalType": "uint256", "name": "vrfFee", "type": "uint256"},
        {"indexed": false, "internalType": "uint8[]", "name": "selectedNumbers", "type": "uint8[]"}
      ],
      "name": "BetPlaced",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {"indexed": true, "internalType": "address", "name": "player", "type": "address"},
        {"indexed": true, "internalType": "uint256", "name": "requestId", "type": "uint256"},
        {"indexed": false, "internalType": "uint256", "name": "amount", "type": "uint256"},
        {"indexed": false, "internalType": "uint8[]", "name": "selectedNumbers", "type": "uint8[]"},
        {"indexed": false, "internalType": "uint8[]", "name": "drawnNumbers", "type": "uint8[]"},
        {"indexed": false, "internalType": "uint8", "name": "hits", "type": "uint8"},
        {"indexed": false, "internalType": "uint256", "name": "payout", "type": "uint256"}
      ],
      "name": "BetSettled",
      "type": "event"
    }
  ];
  
  export default kenoContractABI;